<template>
  <div class="slider-wrapper">
    <input ref="slider" type="range" :min="props.min" :max="props.max" :step="props.step" :value="internalModelValue"
      @input="updateModel($event)" @change="onSliderChange()" :disabled="readonly" orient="vertical"
      :aria-label="ariaLabel" />
    <div v-if="readonly" class="overlay"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, watchEffect, defineProps, defineEmits } from 'vue';

const props = defineProps({
  modelValue: Number,
  min: { type: Number, default: 0 },
  max: { type: Number, default: 10000 },
  selectableMin: { type: Number, default: 1000 },
  step: { type: Number, default: 1 },
  readonly: { type: Boolean, default: false },
  ariaLabel: { type: String, default: "" }
});

const internalModelValue = ref<number>(props.modelValue);

const emit = defineEmits(['update:modelValue', 'change']);

watchEffect(() => {
  internalModelValue.value = props.modelValue;
});

const updateModel = (event: Event) => {
  let value = (event.target as HTMLInputElement).valueAsNumber;

  if (value < props.selectableMin) {
    value = props.selectableMin;
  }

  emit('update:modelValue', value);
};

function onSliderChange() {
  emit("change", internalModelValue.value);
}
</script>

<style scoped>
.slider-wrapper {
  position: relative;
  height: 95%;
  display: flex;
  flex-direction: row;
  text-align: start;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
}

.slider-wrapper input[type=range] {
  -webkit-appearance: slider-vertical;
  -moz-appearance: slider-vertical;
  appearance: slider-vertical;
  width: 100%;
  height: 100%;
  background-color: #ddd;
  border-radius: 5px;
  outline: none;
}

.slider-wrapper input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background-color: #333;
  border-radius: 50%;
  cursor: pointer;
}

.slider-wrapper input[type=range]:disabled::-webkit-slider-thumb {
  cursor: default;
}

.slider-wrapper input[type="range"]:focus::-webkit-slider-thumb {
  box-shadow: 0 0 5px 2px rgba(0, 123, 255, 0.5);
}

.slider-wrapper input[type="range"]:focus::-moz-range-thumb {
  box-shadow: 0 0 5px 2px rgba(0, 123, 255, 0.5);
}

.slider-wrapper input[type="range"]:focus::-ms-thumb {
  box-shadow: 0 0 5px 2px rgba(0, 123, 255, 0.5);
}

.slider-wrapper label {
  margin-top: 10px;
  text-align: center;
}

.scale {
  width: 80px;
}
</style>
